import { Routes } from "@angular/router";
import { APPROUTES } from "../../app.routes.strings";
import { InputsComponent } from "./inputs.component";

export const INPUTS_ROUTES: Routes = [{ path: APPROUTES.inputs, component: InputsComponent }];
